// Singleton — khởi tạo đúng 1 lần khi module load
export const US_STATE_NAMES = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
  CO: "Colorado", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
  HI: "Hawaii",  ID: "Idaho",   IL: "Illinois",  IN: "Indiana",  IA: "Iowa",
  KS: "Kansas",  KY: "Kentucky", LA: "Louisiana", ME: "Maine",   MD: "Maryland",
  MA: "Massachusetts", MI: "Michigan",  MN: "Minnesota", MS: "Mississippi", MO: "Missouri",
  MT: "Montana", NE: "Nebraska", NV: "Nevada",   NH: "New Hampshire", NJ: "New Jersey",
  NM: "New Mexico",   NY: "New York",  NC: "North Carolina", ND: "North Dakota", OH: "Ohio",
  OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
  SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
  VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
  DC: "Washington D.C.",
};

// Singleton — khởi tạo 1 lần, dùng chung toàn bộ app
export const INTL_REGION_NAMES = (() => {
  try { return new Intl.DisplayNames(['en'], { type: 'region' }); }
  catch { return null; }
})();

// Pre-built reverse lookup: Intl wrong name → correct US state name
// Ví dụ: Intl trả "Delaware" cho "DE" → map sang US_STATE_NAMES["DE"] = "Delaware" (khớp)
// Nhưng với code bị misidentify, map giúp correct ngược lại
export const INTL_WRONG_TO_US_STATE = buildIntlWrongToUsMap();

function buildIntlWrongToUsMap() {
  const map = {};
  if (!INTL_REGION_NAMES) return map;
  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  for (const [code, correctName] of Object.entries(US_STATE_NAMES)) {
    try {
      const intlName = INTL_REGION_NAMES.of(code);
      if (intlName && intlName !== correctName && intlName !== code) {
        map[intlName] = { correctName, pattern: new RegExp(`\\b${escapeRegExp(intlName)}\\b`, 'g') };
      }
    } catch {}
  }
  return map;
}

/**
 * Convert một region code đơn lẻ sang display name.
 * - geography = "us": dùng US_STATE_NAMES
 * - geography = khác: dùng Intl.DisplayNames
 */
export function getRegionLabel(code, geography) {
  if (!code) return code;
  if (geography === 'us') {
    // Correct if code is actually a wrong Intl name (e.g. "New Caledonia" for "NC")
    if (INTL_WRONG_TO_US_STATE[code]) {
      return INTL_WRONG_TO_US_STATE[code].correctName;
    }
    return US_STATE_NAMES[code.toUpperCase()] || code;
  }
  try {
    return INTL_REGION_NAMES?.of(code.toUpperCase()) || code;
  } catch {
    return code;
  }
}

/**
 * Correct một đoạn text (có thể chứa nhiều region) trả về từ backend.
 * - Nếu isEntityName = true và code khớp trực tiếp → trả về tên ngay
 * - Thay thế Intl wrong names bằng US state names đúng trong text block
 * - Thay thế state codes trong <strong>/<b> tags
 */
export function getCorrectedText(text, geography, isEntityName = false) {
  if (!text || typeof text !== 'string' || geography !== 'us') return text;

  if (isEntityName && US_STATE_NAMES[text.toUpperCase()]) {
    return US_STATE_NAMES[text.toUpperCase()];
  }

  let corrected = text;

  // 1. Replace Intl wrong names
  for (const { correctName, pattern } of Object.values(INTL_WRONG_TO_US_STATE)) {
    corrected = corrected.replace(pattern, correctName);
  }

  // 2. Replace state codes in HTML bold tags
  for (const [code, name] of Object.entries(US_STATE_NAMES)) {
    corrected = corrected
      .replace(new RegExp(`<strong>\\s*${code}\\s*</strong>`, 'gi'), `<strong>${name}</strong>`)
      .replace(new RegExp(`<b>\\s*${code}\\s*</b>`, 'gi'), `<b>${name}</b>`);
  }

  return corrected;
}
